import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { getUserAreaDomain } from '@/utils/helpers';
import FileDownload from "js-file-download";
import { useState } from "react";
import { API_URL } from "@/config";
import { PackageDownloadTypes } from "@/types";

const embedPlayerVideoLink = () => `${getUserAreaDomain(window.location.origin)}/embed/player`;

const getPlaylistCC = (ccType: PackageDownloadTypes, ccId: number, title: string, institutionId: number) => {
    return axios
        .get(`${API_URL}/api/admin/quiz/${ccType}/${ccId}/cc?videoLink=${embedPlayerVideoLink()}&institutionId=${institutionId}`,
            { responseType: 'blob' })
        .then((response) => {
            const file = new Blob([response.data]);
            FileDownload(file, `${title.toLowerCase().replace(/ /g, '-')}-cc-export.imscc`)
        });
};

/** Quiz V2: GET api/v2/admin/quiz/{quizUuid}/cc — videoLink + institutionId in query (same pattern as v1 CC / V2 SCORM). */
const getAdminQuizV2Cc = (quizUuid: string, title: string, institutionId: number) => {
    const params = new URLSearchParams({
        videoLink: embedPlayerVideoLink(),
        institutionId: String(institutionId),
    });
    return axios
        .get(`${API_URL}/api/v2/admin/quiz/${encodeURIComponent(quizUuid)}/cc?${params.toString()}`, {
            responseType: 'blob',
        })
        .then((response) => {
            const file = new Blob([response.data]);
            const safe = (title || quizUuid).toLowerCase().replace(/ /g, '-');
            FileDownload(file, `${safe}-cc-export.imscc`);
        });
};

export const usePlaylistCC = ({
                                  ccType,
                                  ccId,
                                  title
                              }: { ccType: PackageDownloadTypes, ccId: number; title: string; }) => {
    const { addNotification } = useNotificationStore();
    const [isLoading, setIsLoading] = useState(false);

    const handleCCDownload = async (institutionId: number) => {
        if (ccId && title) {
            try {
                setIsLoading(true);
                await getPlaylistCC(ccType, ccId, title, Number(institutionId));
                setIsLoading(false);
            } catch (error: any) {
                const responseObj = JSON.parse(await error.response.data.text());
                addNotification({
                    type: 'error',
                    title: responseObj.content.message,
                });
                setIsLoading(false);
            }
        }
    };
    return { isLoading, handleCCDownload }
};

export const useAdminQuizV2Cc = ({
    quizUuid,
    title,
}: {
    quizUuid: string;
    title: string;
}) => {
    const { addNotification } = useNotificationStore();
    const [isLoading, setIsLoading] = useState(false);

    const handleCCDownload = async (institutionId: number) => {
        if (quizUuid) {
            try {
                setIsLoading(true);
                await getAdminQuizV2Cc(quizUuid, title, institutionId);
                setIsLoading(false);
            } catch (error: any) {
                const responseObj = JSON.parse(await error.response.data.text());
                addNotification({
                    type: 'error',
                    title: responseObj.content.message,
                });
                setIsLoading(false);
            }
        }
    };
    return { isLoading, handleCCDownload };
};
